export function buildOfficePageURL() {
  return '/my-office'
}
